import { render, staticRenderFns } from "./BkashBanners.vue?vue&type=template&id=406f444b&scoped=true"
import script from "./BkashBanners.vue?vue&type=script&lang=js"
export * from "./BkashBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f444b",
  null
  
)

export default component.exports